// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__Li4JJ","col":"Table_col__n29pG","fulfillmentStatus":"Table_fulfillmentStatus__1wYWD","emailCol":"Table_emailCol__33Wrq"};